import React from 'react';

const SelectState = ({ scheduleChanger, config, scheduleItem }) => {
  const [canSelect, ] = React.useState(config.can_select);
  const [favoriteApi, ] = React.useState(config.favorite_api);
  const [isSelected, setIsSelected] = React.useState(scheduleItem.is_favorite);
  const [isSelectLock, ] = React.useState(!config.can_deselect);
  const [isActiveSession, setActiveSession] = React.useState(scheduleItem.is_active_session || false);
  const [isAvailable, setIsAvailable] = React.useState(scheduleItem.is_available);
  const params = new URLSearchParams(window.location.search)

  React.useEffect(() => {
    const handleUnavailable = (e) => {
      const releases = (e.detail && e.detail.releases) || [];
      const released = releases.some(
        (r) =>
          String(r.scheduleId) === String(scheduleItem.id) &&
          String(r.lineItemId) === String(scheduleItem.line_item_id)
      );
      if (!released) return;

      scheduleItem.is_favorite = false;
      scheduleItem.is_available = false;
      setIsSelected(false);
      setIsAvailable(false);
      setActiveSession(false);
    };

    document.addEventListener('ec:schedule-unavailable', handleUnavailable);
    return () => document.removeEventListener('ec:schedule-unavailable', handleUnavailable);
  }, [scheduleItem]);

  const toggleFavoriteClick = (e, favorite_state) => {
    $.ajax({
      url: favoriteApi,
      type: 'POST',
      data: {
        oid: params.get("oid"),
        rt: params.get("rt"),
        aid: scheduleItem.attendee_id,
        lid: scheduleItem.line_item_id,
        sid: scheduleItem.id,
        state: favorite_state ? 1 : 0
      },
      success: function() {
        scheduleItem.is_favorite = favorite_state
        scheduleItem.is_active_session = true
        setActiveSession(true)
        setIsSelected(favorite_state)
        scheduleChanger()
      },
      error: function(resp) {
        switch (resp.responseJSON?.error) {
          case "conflict":
            alert(resp.responseJSON.message);
            break;
          case "max_capacity":
            scheduleItem.is_available = false
            setIsAvailable(false)
            alert(resp.responseJSON.message);
            break;
          default:
            console.log("Something else went wrong")
        }
      }
    });
  };

  return (
    <span>
      {isSelected ? (
        isSelectLock && !isActiveSession ? (
          <span style={{float: 'right'}} className={'btn btn-small btn-disabled'}>Selected</span>
        ) : (
          <a style={{ float: 'right' }} className={`btn btn-small schedule-select schedule-selected`} onClick={(e) => toggleFavoriteClick(e, !isSelected)}>
            <span className='select-hover-hide'><i className='fas fa-check'></i>Selected</span>
            <span className='select-hover-show'><i className='fas fa-ban'></i>Deselect</span>
          </a>
      )) : (
        (canSelect || isActiveSession) && isAvailable ? (
          <a style={{ float: 'right' }} className={`btn btn-small schedule-select btn-ghost schedule-unselected`} onClick={(e) => toggleFavoriteClick(e, !isSelected)}>
            <i className='fas fa-check'></i>Select
          </a>
        ) : (
          canSelect ? (
            <span style={{float: 'right'}} className={'btn btn-small btn-disabled'}>Unavailable</span>
          ) : ""
        )
      )}
    </span>
  );
};

export default SelectState;
